import React from "react";
import { Drawer, Form, Input, Switch, Button } from "antd";
import TextArea from "antd/es/input/TextArea";

const CreateVendor = ({
    visible,
    onClose,
    onFinish,
    form,
    editingItem,
}) => {
    return (
        <Drawer
            title={editingItem ? "Edit Vendor" : "Add New Vendor"}
            width={500}
            onClose={onClose}
            open={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item
                    name="name"
                    label="Vendor Name"
                    rules={[{ required: true, message: 'Please enter vendor name' }]}
                >
                    <Input size='large' placeholder="Enter name" />
                </Form.Item>

                <Form.Item
                    name="address"
                    label="Vendor Address"
                >
                    <TextArea size='large' placeholder='Enter address' />
                </Form.Item>

                <Form.Item
                    name="note"
                    label="Note"
                >
                    <TextArea size='large' placeholder='Enter notes' />
                </Form.Item>


                <Form.Item
                    name="status"
                    label="Status"
                    valuePropName="checked"
                >
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        style={{ transform: "scale(1.3)", marginTop: "4px" }}
                    />
                </Form.Item>

                <Form.Item>
                    <div
                        style={{
                            textAlign: "right",
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button size="large" type="primary" htmlType="submit">
                            {editingItem ? "Update" : "Create"}
                        </Button>
                        <Button size="large" onClick={onClose}>
                            Cancel
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default CreateVendor;